module.exports = __webpack_public_path__ + "img/37-ABITO-AGADI-SML-STAMPE-LINO-UNITI-LINO--CINTURA-ZIONE-U-COLORI-LINO-STAMPA-LINO6.eb17d8be.jpg";